import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Modal } from "../../../../../../shared/Modal/Modal";
import { Button } from "../../../../../../shared/Button/Button";
import styles from "../scss/OneClickCancellation.module.scss";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import { Select } from "../../../../../../shared/Select/Select";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { useEditClinicsLoyaltyList } from "../hooks/useEditClinicsLoyaltyList";
import { useClinicsLoyaltyList } from "../hooks/useClinicsLoyaltyList";
import { QUERY_KEYS } from "../../../../../../consts/api";
import { uiNotification } from "../../../../../../services/UINotificationService";

const OneClickCancellationModal = ({ onClose, activeClinics }) => {
  const queryClient = useQueryClient();
  const [selectedLocations, setSelectedLocations] = useState(
    activeClinics || [],
  );

  const { data, isLoading } = useClinicsLoyaltyList();

  const { mutate, isLoading: isMutating } = useEditClinicsLoyaltyList({
    onSuccess: () => {
      uiNotification.success("Clinics List updated successfully.");
    },
    onError: () => {
      uiNotification.error("Something went wrong. Please try again.");
    },
  });

  const disableLocation = data?.filter(
    (el) =>
      !selectedLocations.some((selectedLoc) => selectedLoc.value === el.value),
  );

  return (
    <Modal
      isOpen
      withCloseBtn
      onClose={onClose}
      header={<h2>Select Locations</h2>}
      footer={
        <Button
          size="small"
          leftAdornment={
            isMutating ? <CircularProgress size="small" color="white" /> : null
          }
          isDisabled={isMutating}
          onClick={() =>
            mutate(
              { clinic_ids: disableLocation.map((loc) => loc.value) },
              {
                onSuccess: () => {
                  onClose();
                  queryClient.invalidateQueries([
                    QUERY_KEYS.clinicsLoyaltyList,
                  ]);
                },
              },
            )
          }
        >
          Save
        </Button>
      }
      footerClassName={styles.modalFooter}
      headerNoBorder
      footerNoBorder
    >
      {isLoading ? (
        <CircularProgress className={styles.loader} />
      ) : (
        <div>
          <InputLabel>Locations</InputLabel>
          <Select
            options={data}
            value={selectedLocations}
            onChange={(selected) => setSelectedLocations(selected)}
            isMulti
          />
        </div>
      )}
    </Modal>
  );
};

export default OneClickCancellationModal;
